import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useLanguageStore, type Language } from '../../app/store/language-store';

interface LanguageSwitcherProps {
  variant?: 'default' | 'ghost' | 'outline';
  size?: 'default' | 'sm' | 'lg';
  showText?: boolean;
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  variant = 'ghost',
  size = 'default',
  showText = false,
}) => {
  const { t } = useTranslation();
  const { currentLanguage, availableLanguages, setLanguage } = useLanguageStore();

  const handleLanguageChange = () => {
    const currentIndex = availableLanguages.indexOf(currentLanguage);
    const nextIndex = (currentIndex + 1) % availableLanguages.length;
    const nextLanguage = availableLanguages[nextIndex];
    setLanguage(nextLanguage);
  };

  const getLanguageLabel = (lang: Language) => {
    return t(`language.${lang === 'ru' ? 'russian' : 'english'}`);
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleLanguageChange}
      className="flex items-center gap-2"
      title={t('language.switchLanguage')}
    >
      <Globe className="h-4 w-4" />
      {showText && (
        <span className="hidden sm:inline">
          {getLanguageLabel(currentLanguage)}
        </span>
      )}
    </Button>
  );
};